import React from 'react';

const EmptyPage = () => {
    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    
                </div>
            </div>
        </div>
    );
};

export default EmptyPage;
